export type PageField = {
  type: 'enum' | 'boolean' | 'date' | 'text';
  values?: ReadonlyArray<string | null>;
  multiple?: boolean;
  maxSelections?: number;
  maxLength?: number;
};
export type PageView = {
  title: string;
  ready: boolean;
  filters: Record<string, unknown>;
  filterSchema: Record<string, PageField>;
  [key: string]: unknown;
};
export type PageCapabilities = {
  set_filters: { fields: Record<string, PageField>; scope: 'current_view' };
};
export type PageSnapshot = PageView & {
  version: 1;
  instanceId: string;
  revision: number;
  capabilities: PageCapabilities;
};

/** A refused read must not carry stale numerical payloads in its rejection snapshot. */
export function authoritativePageView(view: PageView): PageView {
  return view.ready
    ? view
    : {
        title: view.title,
        ready: false,
        filters: view.filters,
        filterSchema: view.filterSchema,
      };
}
export type PageAdapter = {
  pageId: string;
  view: PageView;
  edit: (filters: Record<string, unknown>) => void;
};
export type PageRequest = {
  version: 1;
  pageId: string;
  connectionId: string;
  requestId: string;
  operation: 'read' | 'edit' | 'cancel';
  expectedRevision?: number;
  expiresAt: number;
  changes?: { filters?: Record<string, unknown> };
};
export type PageResult = {
  status: 'ready' | 'applied' | 'rejected' | 'cancelled' | 'unknown';
  applied?: boolean;
  code?: string;
  error?: string;
  view?: PageSnapshot;
};
